import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Title = styled.h3`
  font-size: 22px;
  text-align: center;
  margin-bottom: 20px;
`;

export const CreateBox = styled.div<{ disable?: boolean }>`
  padding-top: 10px;
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  flex-direction: column;

  > span {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 2px;
  }

  input,
  textarea {
    width: 100%;
    font-size: 14px;
    border: 1px solid #d4d4d4;
    border-radius: 3px;
    padding: 8px 10px;

    &:focus {
      outline: none;
    }
  }

  textarea {
    min-height: 80px;
    resize: none;
  }
`;

export const CustomBox = styled.div<{ disable?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: end;
  position: absolute;
  top: 10px;
  right: 20px;

  > span {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 2px;
  }
`;

export const DeleteBox = styled.div<{ disable?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  position: absolute;
  top: 10px;
  left: 20px;

  > span {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 2px;
  }

  > button {
    padding: 2.8px;
    width: 30px;
    border-radius: 25px;
    color: white;
    background-color: ${(props) => props.theme.colors.placeholderColor};
  }
`;

export const DateBox = styled.div`
  display: flex;
  gap: 30px;

  > div {
    display: flex;
    flex-direction: column;
    font-size: ${(props) => props.theme.fontSizes.medium}px;
    justify-content: start;
    z-index: 2 !important;
    width: 100%;

    p {
      display: block;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 2px;
    }

    &:nth-child(1) {
      z-index: 4 !important;
    }

    input {
      padding: 0px 10px !important;
    }
  }
`;

export const PreviewBox = styled.div`
  padding-top: 20px;
  max-width: 170px;
  display: flex;
  flex-direction: column;

  > span {
    display: block;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
    text-align: center;
  }
`;

export const CDiv = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;

  ${mq(Devices.mobile)} {
    grid-gap: 15px;
    grid-template-columns: 1fr 1fr;
  }
`;

export const IconDDL = styled.div<{ height?: boolean }>`
  height: ${(props) => (props.height? "auto" : '55px')};
  overflow: hidden;
  width: 100%;
  font-size: 14px;
  border: 1px solid #d4d4d4;
  border-radius: 3px;
  padding: 8px 10px;
  position: relative;
  transition: height 0.3s ease-in-out;

  > svg {
    transition: all 0.3s ease-in-out;
    transform: rotate(${(props) => (props.height? '180deg' : '0deg')});
  }
`;

export const DDPreview = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px;
  cursor: pointer;

  svg {
    margin-left: auto;
    width: 26px;
  }
`;

export const DD = styled.div`
  width: 100%;
  background: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  padding: 10px;
  gap: 10px;
  border-radius: 0 0 3px 3px;
`;

export const DDItem = styled.div`
  border: 1px solid #494949;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  background: #c9c9c96a;

  &:hover {
    background: #12acdb6a;
  }
`;

export const NavButton = styled.button<{ disabled?: boolean, red?:boolean }>`
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  background: ${(props) => (props.disabled ? '#A0A0A0' : props.red?props.theme.colors.red :props.theme.colors.placeholderColor)};
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  cursor: pointer !important;

  &:hover {
    opacity: 0.9;
  }
`;

export const Popup = styled.div<{ show?: boolean }>`
  position: fixed;
  background: #ffffff45;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1200;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

export const PopupBox = styled.div`
  position: relative;
  max-width: 320px;
  width: 100%;
  min-height: 150px;
  background: #fff;
  border-radius: 5px;
  padding: 50px 20px 20px 20px;
  overflow: hidden;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);

  p {
    font-size: 16px;
  }

  div:nth-of-type(2) {
    display: flex;
    width: 100%;
    gap: 20px;
    margin-top: 30px;

    button {
      width: 100%;
      background: #2a848e;
      color: #fff;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 500;
      padding: 8px 0;
    }
  }
`;

export const BoxTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 34px;
  background: #2a848e;
  display: flex;
  align-items: center;

  span {
    color: #fff;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }

  button {
    width: 16px;
    color: #fff;
    margin-left: auto;
    margin-right: 10px;
    margin-top: 4px;
    path {
      fill: #fff;
    }
  }
`;
